import { Injectable } from '@angular/core';
import { IntegrationService } from './integration.service';
import { StatusViewService } from './status-view.service';
import { CoreService } from '@charlesschwab/sac-ui-core';
import { AsContextAttributes } from '../models/AsContextAttributes';
import { Constants } from '../utilities/Constants';

@Injectable()
export class ActionCenterRedirectService {
  constructor(
    private integrationService: IntegrationService,
    private statusViewService: StatusViewService,
    private sacCoreService: CoreService
  ) {}

  // TODO: Call the new endpoint to grab context id from this service and add it to the url
  redirectToActionCenter() {
    let actionCenterUrl: string;
    let env = this.integrationService.JfkEnv.EnvironmentHeader.toLowerCase();
    if (env === 'prod') {
      actionCenterUrl = 'https://actioncenter.schwab.com';
    } else {
      if (env === 'qae01'){
        actionCenterUrl = `https://actioncenter-qa.dev.schwab.tech`;
      } else if (env === 'sit01') {
        actionCenterUrl = `https://actioncenter-dev.dev.schwab.tech`;
      } else {
        actionCenterUrl = `https://actioncenter-${env}.dev.schwab.tech`;
      }
    }

    let contextRequest: AsContextAttributes = {
      sessionId: 'MoneyMovementSessionId',
      subject: Constants.ADVISOR_CENTER_URN,
      audience: Constants.ADVISOR_CENTER_URN,
      logonId: this.sacCoreService.currentUserContext.userName,
      format: 'JSON',
      context: `{\"accountNumber\":\"${this.sacCoreService.currentContext.contextId}\", \"actionRegistryId\":\"MoneyLinkSA\"}`,
    };

    this.statusViewService.getContextId(contextRequest).subscribe({
      next: (data) => {
        let contextparam = data.data.id ? `${data.data.id}&` : '';
        let redirectPath = encodeURIComponent(
          actionCenterUrl +
            `/envelope/AccountMaintenance?${contextparam}sourceLink=AccountMaintenance&actorType=SacAdvisor`
        );
        window.open(
          `${actionCenterUrl}/api/unifiedauth/login?path=${redirectPath}`,
          '_blank'
        );
      },
      error: (err) => {
        let redirectPath = encodeURIComponent(
          actionCenterUrl +
            `/envelope/AccountMaintenance?sourceLink=AccountMaintenance&actorType=SacAdvisor`
        );
        window.open(
          `${actionCenterUrl}/api/unifiedauth/login?path=${redirectPath}`,
          '_blank'
        );
      },
    })
  }
}
